import { Info } from "@phosphor-icons/react"

interface ChatUnavailableBlockProps {
  validated?: unknown
}

function reasonOf(value: unknown): string | null {
  const reason = (value as { reason?: unknown } | null | undefined)?.reason
  return typeof reason === "string" && reason.trim().length > 0 ? reason.trim() : null
}

export default function ChatUnavailableBlock({ validated }: ChatUnavailableBlockProps) {
  const reason = reasonOf(validated)
  if (!reason) return null

  return (
    <div className="my-2 flex min-w-0 items-start gap-2 rounded-lg bg-subtle p-3 text-fg-subtle">
      <Info className="mt-0.5 shrink-0" />
      <span className="paragraph-sm">{reason}</span>
    </div>
  )
}
